"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Number_With_Commas = void 0;

Number_With_Commas = function () {
    function Number_With_Commas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    return Number_With_Commas;
}();

exports.default = Number_With_Commas;